import React from 'react';
import { Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { formatUSD } from '../../../../../utils/formatCurrency';
import { formatHours } from '../../../../../utils/formatHours';

const NonBillableCell = ({ value, row }) => {
  const nonBillableTotal = Number(row?.original?.moneyNonBillable) || 0;
  const nonBillableQuantityTotal = Number(row?.original?.timeNonBillable) || 0;

  if (row?.original?.isTotalRow) {
    return (
      <Typography
        sx={{
          fontSize: '16px',
          fontWeight: 700,
          textAlign: 'right',
          width: '100%',
        }}
      >
        {formatUSD(nonBillableTotal)}
        <br />
        {formatHours(nonBillableQuantityTotal)}
      </Typography>
    );
  }

  return (
    <Typography
      sx={{
        fontSize: '16px',
        fontWeight: 500,
        textAlign: 'right',
        width: '100%',
      }}
    >
      {value ? formatUSD(value) : null}
    </Typography>
  );
};

NonBillableCell.propTypes = {
  value: PropTypes.string,
  row: PropTypes.shape({
    original: PropTypes.shape({
      moneyNonBillable: PropTypes.string,
      timeNonBillable: PropTypes.string,
      isTotalRow: PropTypes.bool,
    }),
  }).isRequired,
};

NonBillableCell.defaultProps = {
  value: '',
};

export default NonBillableCell;
